module.exports = __webpack_public_path__ + "assets/80cd57fde2574c5513b682b2c403fcfe.mp3";